<form [formGroup]="form" (ngSubmit)="SaveUser()">
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <label for="email" class="form-label" translate="Settings.AccountProfileSection.EmailAddress">
            <app-info-button labelName="Settings.AccountProfileSection.EmailAddressTooltip" [url]="UsersUrl">
            </app-info-button>
        </label>
        <input type="text" id="email" class="form-control" value="{{ user.email }}" disabled>
        <app-formcontrol-error-messages [forControl]="emailControl"></app-formcontrol-error-messages>
    </div>
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <label for="givenName" class="form-label" translate="Settings.AccountProfileSection.GivenName"></label>
        <input type="text" id="firstname" class="form-control" formControlName="firstname" value="{{ user.firstname }}">
        <app-formcontrol-error-messages [forControl]="firstNameControl"></app-formcontrol-error-messages>
    </div>
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <label for="prefix" class="form-label" translate="Settings.AccountProfileSection.Preposition"></label>
        <input type="text" id="prefix" class="form-control" formControlName="prefix" value="{{ user.prefix }}">
        <app-formcontrol-error-messages [forControl]="prefixControl"></app-formcontrol-error-messages>
    </div>
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <label for="lastname" class="form-label" translate="Settings.AccountProfileSection.Surname"></label>
        <input type="text" id="lastname" class="form-control" formControlName="lastname" value="{{ user.lastname }}">
        <app-formcontrol-error-messages [forControl]="lastNameControl"></app-formcontrol-error-messages>
    </div>
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <label for="phoneNumber" class="form-label"
            translate="Settings.AccountProfileSection.MobilePhoneNumber"><app-info-button
                labelName="Settings.AccountProfileSection.PhoneNumberTooltip"></app-info-button></label>
        <input type="text" id="phoneNumber" class="form-control" formControlName="phoneNumber"
            value="{{ user.phoneNumber }}">
        <app-formcontrol-error-messages [forControl]="phoneNumberControl"></app-formcontrol-error-messages>
    </div>
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <label for="organisation" class="form-label" translate="Settings.AccountProfileSection.Organisation">
            <app-info-button labelName="Settings.AccountProfileSection.OrganisationTooltip"></app-info-button>
        </label>
        <input type="text" id="organisation" class="form-control" value="{{ user.organisation }}" disabled>
        <app-formcontrol-error-messages [forControl]="organisationControl"></app-formcontrol-error-messages>
    </div>
    <div class="mb-3 pb-1 w-100 d-table d-block col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <label for="userLanguage" class="form-label"
            translate="Settings.AccountProfileSection.Language"><app-info-button
                labelName="Settings.AccountProfileSection.LanguageTooltip"></app-info-button></label>
        <div ngbDropdown class="dropdown" ngDefaultControl formControlName="language" name="userLanguage"
            id="userLanguage">
            <button class="btn btn-sm language dropdown-toggle form-control text-truncate default" type="button"
                id="dropdownMenu" ngbDropdownToggle>
                {{ userLanguage | translate }}
                <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                <button ngbDropdownItem value="nl" (click)="setUserLanguageWithEvent($event, 'nl')"
                    translate="Language.Dutch"></button>
                <button ngbDropdownItem value="en" (click)="setUserLanguageWithEvent($event, 'en')"
                    translate="Language.English"></button>
            </div>
        </div>
        <app-formcontrol-error-messages [forControl]="languageControl"></app-formcontrol-error-messages>
    </div>
    <div class="mb-3 pb-1 w-100 d-table d-block col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <button [disabled]="awaitingRequest || form.invalid" type="submit" id="buttonSave"
            class="btn btn-sm btn-primary float-end mt-4" translate="Button.SaveChanges"></button>
    </div>
</form>